
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            currentIndex: 0, //点击索引
            nav: [
                {
                    title: '首页',
                    path: '/',
                },
                {
                    title: '资讯中心',
                    path: '/realinfo/',
                    path2: '/realinfo/detail/',
                },
                {
                    title: '游戏中心',
                    path: '/game/',
                },
                {
                    title: '礼包中心',
                    path: '/giftbag/',
                    path2: '/giftbagDetail/',
                },
                {
                    title: '用户中心',
                    path: '/user/',
                },
            ],
        }
    },
    computed: {
        ...mapGetters(['vip', 'uname']),
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                if (val.path == '/login') {
                    this.currentIndex = null
                } else {
                    let path = this.nav.findIndex(
                        (item) =>
                            item.path == this.$route.path ||
                            item.path2 == this.$route.path
                    )
                    this.currentIndex = path
                }
            },
            // 深度观察监听
            deep: true,
        },
        // uname: {
        // handler(newVal, old) {
        //     if (newVal && this.$route.path != '/register/') {
        //         this.currentIndex = 0
        //     } else {
        //         this.currentIndex = null
        //     }
        // },
        // deep: true,
        // },
    },
    created() {
        // 刷新保持选中高亮状态
        this.currentIndex = Number(
            this.nav.findIndex(
                (item) =>
                    item.path == this.$route.path ||
                    item.path2 == this.$route.path
            )
        )
    },
    methods: {
        // 点击时的下划线跟随效果
        clickTab(index) {
            this.currentIndex = index
        },
        get_logo() {
            this.currentIndex = 0
            this.$router.push('/')
        },
    },
}
